import { getCurrYear } from "./getCurrYear";

/**
 *
 * getPrevYear :: () -> Number
 *
 * @return {number}
 */
export const getPrevYear = () => getCurrYear() - 1;
